<template>
    <div class="w-full h-screen hidden md:block">
        <WorkflowSettingsModal v-model:is-active="isSettingsOpen"/>
        <ConnectionDeleteModal v-model:is-active="isConnectionDeleteVisible" v-model:connection-for-delete="connectionForDelete"/>
        <SummaryModal v-model:is-visible="isSummaryModalVisible" v-model:connection-id="connectionSummaryId" v-model:refresh-trigger="refreshTrigger"/>
        <div class="page-content justify-between flex mr-0 overflow-y-hidden h-screen w-full">
            <NavigationBar />
            <div class="h-full w-full relative">
                <div class="flex items-center max-w-80 py-3 pr-7 bg-white absolute top-10 left-20 z-20 rounded-md shadow-xl xl:max-w-[calc(600px)]">
                    <div
                        class="rounded-full min-w-12 min-h-12 flex justify-center items-center ml-5"
                        v-bind:class="getColorClass()"
                    >
                    <span class="text-xl font-bold text-white select-none">
                        {{getFirstLetters(this.newName)}}
                    </span>
                    </div>
                    <div class="block ml-5 text-xl font-bold w-full truncate select-none">
                        <InputField v-model="this.newName" />
                    </div>
                    <div class="ml-4 flex gap-2" v-show="this.workflow.name !== this.newName">
                        <div
                            class="rounded-full size-10 hover:bg-gray-100 flex items-center justify-center cursor-pointer"
                            v-on:click="updateName"
                        >
                            <TickBlackSvg class="size-6"/>
                        </div>
                        <div
                            class="rounded-full size-10 hover:bg-gray-100 flex items-center justify-center cursor-pointer"
                            v-on:click="returnName"
                        >
                            <CrossCloseNotifySvg class="size-6"/>
                        </div>
                    </div>

                </div>
                <div class="hidden absolute top-10 right-10 z-20 xl:flex">
                    <div class="w-48 h-10 bg-white rounded-md shadow-md font-bold flex justify-center items-center select-none cursor-pointer mr-5 hover:bg-gray-100"
                         v-on:click="redirectToCreateConnection"
                    >
                        Создать соединение
                    </div>
                    <div class="w-48 h-10 bg-white rounded-md shadow-md font-bold flex justify-center items-center select-none cursor-pointer mr-5 hover:bg-gray-100"
                         v-on:click="redirectToTransactionsJournal"
                    >
                        Журнал транзакций
                    </div>
                    <div class="w-32 h-10 bg-white rounded-md shadow-md font-bold flex justify-center items-center select-none cursor-pointer mr-5 hover:bg-gray-100"
                         v-on:click="openSettings"
                    >
                        Настройки
                    </div>
                </div>
                <div class="flex absolute top-10 right-10 z-20 xl:hidden">
                    <div class="w-20 h-10 bg-white rounded-md shadow-md font-bold flex justify-center items-center select-none cursor-pointer mr-5 hover:bg-gray-100"
                         v-on:click="redirectToCreateConnection"
                    >
                        <PlusCircleSvg class="size-6 stroke-2" />
                    </div>
                    <div class="w-20 h-10 bg-white rounded-md shadow-md font-bold flex justify-center items-center select-none cursor-pointer mr-5 hover:bg-gray-100"
                         v-on:click="openSettings"
                    >
                        <SettingsSvg class="size-6 stroke-2" />
                    </div>
                </div>
                <div class="absolute z-20 bottom-10 left-20 w-40 h-10
                        font-bold bg-white shadow-md rounded-md hover:bg-gray-100
                        flex items-center justify-center select-none cursor-pointer"
                     v-on:click="startWorkflow"
                >
                    Запустить всё
                </div>
                <FlowComponent v-model="this.flowItems" size="full" maxZoom="1.5"/>
            </div>
            <SideBarMenu
                :workflow_id="this.$route.params.workflow_id"
                v-model:reload-connections="this.reloadStatuses"
                @start-connection="changeConnectionStyleRunning"
                @stop-connection="changeConnectionStyleStopped"
                @open-summary="openSummary"
                @hover-on="hoverConnection"
                @hover-off="unHoverConnection"
                @delete-connection="deleteConnection"
                v-model:refresh-trigger="refreshTrigger"
            />
        </div>
    </div>
    <div class="w-full h-screen block md:hidden overflow-hidden">
        <div class="w-full h-full">
            <div class="w-full h-full">
                <div class="w-full h-14 flex items-center justify-center px-4 bg-white">
                    <BackSvg class="size-6" v-on:click="this.$router.push({name: 'WorkspaceView'})"/>
                    <div class="block ml-5 text-xl font-bold w-full truncate select-none">
                        {{ this.workflow.name }}
                    </div>
                </div>
                <div class="w-full h-full bg-white" v-if="menuState === 'connections'">
                    <ConnectionsView :workflow_id="this.$route.params.workflow_id" />
                </div>
                <div class="w-full h-full bg-white" v-if="menuState === 'files'">
                    <FilesView :workflow_id="this.$route.params.workflow_id" />
                </div>
                <div class="w-full h-full bg-white" v-if="menuState === 'settings'">
                    <SettingsView />
                </div>
            </div>
            <BottomBarMenu class="w-full" v-model="menuState"/>
        </div>
    </div>

</template>

<script>
import NavigationBar from '../../components/NavigationBar.vue'
import FlowComponent from '../FlowComponent.vue';
import { Api } from '@/service/api';
import { colors } from '@/service/config';
import SideBarMenu from './SideBarMenu.vue';
import WorkflowSettingsModal from './WorkflowSettingsModal.vue';
import PlusCircleSvg from "@/components/UI/svg/PlusCircleSvg.vue";
import SettingsSvg from "@/components/UI/svg/SettingsSvg.vue";
import BottomBarMenu from "@/pages/Flow/BottomBarMenu.vue";
import BackSvg from "@/components/UI/svg/BackSvg.vue";
import ConnectionsView from "@/pages/Flow/ConnectionsView.vue";
import FilesView from "@/pages/Flow/FilesView.vue";
import SettingsView from "@/pages/Flow/SettingsView.vue";
import InputField from "@/components/UI/InputField.vue";
import TickBlackSvg from "@/components/UI/svg/TickBlackSvg.vue";
import CrossCloseNotifySvg from "@/components/UI/svg/CrossCloseNotifySvg.vue";
import ConnectionDeleteModal from "@/components/ConnectionDeleteModal.vue";
import SummaryModal from "@/pages/Flow/SummaryModal.vue";
import {ref} from "vue";

export default {
    name: 'FlowView',
    components: {
        SummaryModal,
        CrossCloseNotifySvg,
        TickBlackSvg,
        SettingsView,
        FilesView,
        ConnectionsView,
        BackSvg,
        BottomBarMenu,
        SettingsSvg,
        PlusCircleSvg,
        NavigationBar,
        FlowComponent,
        SideBarMenu,
        WorkflowSettingsModal,
        InputField,
        ConnectionDeleteModal
    },
    data() {
        return {
            workflow: {},
            files: [],
            flowItems: [],
            bufferFlowItems: [],
            edgeTypes: {},
            connections: [],
            flowObjects: {},
            nodesDraggable: false,
            isLoaded: false,
            currentState: 'Соединения',
            closeBody: false,
            isSideBarVisible: true,
            isSettingsOpen: false,
            menuState: "connections",
            settings: {},
            workflow_id: "",
            timeoutId: null,
            reloadStatuses: false,
            newName: "",
            isConnectionDeleteVisible: false,
            connectionForDelete: "",
            isSummaryModalVisible: false,
            connectionForSummary: {},
            connectionSummaryId: "",
            refreshTrigger: ref(false)
        }
    },
    beforeCreate: async function() {
        this.workflow_id = this.$route.params.workflow_id
        this.workflow = await Api.getWorkflow(this.workflow_id)

        this.newName = this.workflow.name

        this.settings = this.workflow.settings
        this.flowObjects = await Api.getFlowObjects(this.$route.params.workflow_id)

        this.flowItems = this.getFlowItems(this.flowObjects.objects)

        this.bufferFlowItems = this.flowItems

        console.log(this.flowObjects)

        this.flowItems.push(...this.getFilesConnections(this.flowObjects.connections))
        this.connections = this.processConnections(this.flowObjects.connections)

        console.log(this.workflow)
        console.log(this.connections)
        this.isLoaded = true
        this.timeoutId = setTimeout(
            this.updateFilesPositions, 1000
        ) // Отправляем сохранение позиций каждые 5 секунд
    },
    unmounted() {
        clearTimeout(this.timeoutId)
    },
    methods: {
        deleteConnection: function(value) {
            this.connectionForDelete = value
            this.isConnectionDeleteVisible = true
        },
        redirectToCreateConnection: function() {
            this.$router.push({name: 'CreateConnection', params: {workflow_id: this.$route.params.workflow_id}})
        },
        redirectToTransactionsJournal: function() {
            this.$router.push({name: 'TransactionJournal', params: {workflow_id: this.$route.params.workflow_id}})
        },
        returnName: function() {
            this.newName = this.workflow.name
        },
        updateName: async function() {
            await Api.updateWorkflowName(this.$route.params.workflow_id, this.newName)
            this.workflow.name = this.newName
        },
        openSummary: function(connection_id) {
            this.isSummaryModalVisible = true
            this.connectionSummaryId = connection_id
        },
        getFirstLetters: function() {
            if (this.workflow.name === undefined) return "Б"
            const strings = this.workflow.name.split(" ")
            if (strings.length < 2) {
                return strings[0][0]
            }
            if (strings[1][0] === undefined) {
                return strings[0][0]
            }
            return (strings[0][0] + strings[1][0])
        },
        updateFilesPositions: async function() {
            let filesForUpdate = []
            for (let i = 0; i < this.bufferFlowItems.length; i++) {
                if (this.bufferFlowItems[i]?.position === undefined){ continue; }

                if ((this.bufferFlowItems[i].position.x !== this.flowItems[i].position.x) ||
                    (this.bufferFlowItems[i].position.y !== this.flowItems[i].position.y)) {
                    this.bufferFlowItems[i].position.x = this.flowItems[i].position.x;
                    this.bufferFlowItems[i].position.y = this.flowItems[i].position.y;

                    filesForUpdate.push({
                        "file_id": this.bufferFlowItems[i].id,
                        "pos_x": this.bufferFlowItems[i].position.x,
                        "pos_y": this.bufferFlowItems[i].position.y,
                    })
                }
            }
            if (filesForUpdate.length > 0) {
                await Api.updateFilesPositions(
                    this.$route.params.workflow_id,
                    filesForUpdate,
                )
            }
            this.timeoutId = setTimeout(this.updateFilesPositions, 1000)
        },
        getFlowItems: function(flowObjects) {
            let flowItems = []
            flowObjects.forEach((item) => {
                flowItems.push(
                    {
                        id: item.id,
                        label: item.label,
                        position: {
                            x: item.pos_x,
                            y: item.pos_y
                        },
                        type: item.obj_type,
                        connection_id: item.connection_id,
                        data: {
                            isLoading: false,
                            label: "",
                            isHover: false,
                            spreadsheet_id: item.spreadsheet_id,
                        }
                    }
                )
            })
            return flowItems
        },
        getColorClass: function() {
            return colors[this.workflow.color]?.class
        },
        startWorkflow: async function() {
            this.reloadStatuses = true
            await Api.startWorkflow(this.workflow.id)
        },
        processConnections: function(connections) {
            let data = []

            for (let i = 0; i < connections.length; i++) {
                data.push(connections[i])
                data[i].id = i + 1
            }

            return data
        },
        getFilesConnections: function(flowConnections) {
            let conn = []
            flowConnections.forEach(
                (value) => {
                    conn.push(
                        {
                            id: "el" + value.source + "_" + value.target,
                            source: value.source.toString(),
                            target: value.target.toString(),
                            sourceHandle: "right",
                            targetHandle: "left",
                            type: 'custom',
                            animated: true,
                            label: "",
                            connection_id: value.connection_id,
                            data: {  // <-- Все кастомные props должны быть внутри data
                                isLoading: false,
                                label: "",
                                isHover: false
                            }
                        }
                    )
                }
            )
            return conn
        },
        changeConnectionStyleRunning: function(connection_id) {
            for (const conn of this.flowItems) {
                if (conn?.connection_id !== undefined && conn.connection_id === connection_id) {
                    conn.data.isLoading = true
                }
            }
        },
        changeConnectionStyleStopped: function(connection_id) {
            for (const conn of this.flowItems) {
                if (conn?.connection_id !== undefined && conn.connection_id === connection_id) {
                    conn.data.isLoading = false
                }
            }
        },
        hoverConnection: function(connection_id) {
            for (const conn of this.flowItems) {
                if (conn?.connection_id !== undefined && conn.connection_id === connection_id) {
                    if (!conn.data.isHover) {
                        conn.data.isHover = true
                    }

                }
            }
        },
        hoverFile: function(file_id) {
            console.log(file_id)
            for (const conn of this.flowItems) {
                console.log(conn.spreadsheet_id)
                if (conn.data.spreadsheet_id === file_id) {
                    conn.data.isHover = true
                    console.log("HOVER")
                }
            }
        },
        unHoverFile: function(file_id) {
            for (const conn of this.flowItems) {
                if (conn?.spreadsheet_id !== undefined && conn.spreadsheet_id === file_id) {
                    conn.data.isHover = false
                }
            }
        },
        unHoverConnection: function(connection_id) {
            for (const conn of this.flowItems) {
                if (conn?.connection_id !== undefined && conn.connection_id === connection_id) {
                    conn.data.isHover = false

                }
            }
        },
        setState: function(state) {
            if (state === 'Файлы' || state === 'Соединения') {
                this.currentState = state
            }
        },
        openSettings: function() {
            this.isSettingsOpen = true
        }
    }
}

</script>

<style scoped>

    /* these are necessary styles for vue flow */
    @import 'https://cdn.jsdelivr.net/npm/@vue-flow/core@1.33.5/dist/style.css';
    @import 'https://cdn.jsdelivr.net/npm/@vue-flow/core@1.33.5/dist/theme-default.css';
    @import 'https://cdn.jsdelivr.net/npm/@vue-flow/controls@latest/dist/style.css';
    @import 'https://cdn.jsdelivr.net/npm/@vue-flow/minimap@latest/dist/style.css';
    @import 'https://cdn.jsdelivr.net/npm/@vue-flow/node-resizer@latest/dist/style.css';

    .page-content {
        display: flex;
    }
    .hover-change-id:hover ~ .hover-change-id-visible{
        display: block;
    }
    .hover-change-id:hover ~ .hover-change-id-hidden{
        display: none;
    }
    .custom-shadow {
        box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
                    0px 8px 10px 1px rgba(0, 0, 0, 0.14),
                    0px 3px 14px 2px rgba(0, 0, 0, 0.12);
    }
</style>
